import useComponentDidMount from 'Hooks/useComponentDidMount';
import { redirectToMaintenance } from 'Helpers/Redirect';

const NoHomeResource = () => {
  useComponentDidMount(() => {
    redirectToMaintenance();
  });

  return null;
};

export default NoHomeResource;
